import React from "react";
import moment from "moment";
import config from "./../config";
import Link from '@material-ui/core/Link';

// Simple test to determine if a string is a path or URL
const pattern = new RegExp('^https?://');

export const generateColumns = () => [
    {
        Header: 'Date',
        accessor: 'publishedAt',
        Cell: props => moment(props.value).format(config.dateFormat)
    },
    {
        Header: 'Title',
        accessor: 'title'
    },
    {
        Header: 'Link',
        accessor: 'url',
        Cell: props => {
            let url = props.value;
            if (!pattern.test(url)) {
                url = config.baseEndpoint + url;
            }
            return <Link href={url} target="_blank" rel="noopener noreferrer">View article</Link>
        }
    }
];
